var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('layoutLeft'),_c('div',{staticClass:"app"},[_c('layoutTop'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }